<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template functional>
  <footer
    class="flex-wrap justify-between the-footer"
    :class="classes"
    style="position: fixed;
    z-index: 1000;
      bottom: 0px;
    justify-content: space-around;
    align-items: center;
    width: 100%;
   background-color: rgb(3 38 95);
    height: 45px;
    box-shadow: 5px 10px 20px 7px;"
  >
    <router-link to="about-us" class="text-white">
      <p>
        <i class="fa fa-briefcase" />
        About Us
      </p>
    </router-link>
    <router-link to="privacy-policy" class="text-white">
      <p>
        <i class="fa fa-shield" />
        Privacy Policy
      </p>
    </router-link>
    <router-link to="distance-sales-agreement" class="text-white">
      <p>
        <i class="fa fa-shopping-cart" />
        Distance Sales Agreement
      </p>
    </router-link>
    <router-link to="cookie-policy" class="text-white">
      <p>
        <i class="fa fa-book" />
        Cookie Policy
      </p>
    </router-link>
    <span class="items-center hidden text-white md:flex">
      <p>
        <span>COPYRIGHT &copy;</span>
        <span>{{ new Date().getFullYear() }}</span>
        <a href="https://malwation.com" target="_blank" rel="nofollow" class="ml-2 text-white">Malwation</a>
        <span class="hidden sm:inline-block">, All rights Reserved</span>
      </p>
    </span>
  </footer>
</template>

<script>
export default {
  name: "the-footer",
  props: {
    classes: {
      type: String,
    },
  },
};
</script>
